import batchFunction from '@/utils/batchFunction';
import callApi from '@/utils/callApi';
import state from '@/state';

// @TODO also memoize? :D
const getProductRatings = batchFunction(async function (ids) {
  const commentTypes = ['product_review'];

  if (state.merchantConfig.comments.product_hype.enabled) {
    commentTypes.push('product_hype');
  }

  const res = await callApi('GET', '/v1/comment-ratings/' + commentTypes.join(',') + '/' + ids.join(',') + '?group_targets');
  const { summaries } = await res.json();
  return summaries;
}, 1);

export default getProductRatings;
